import React from "react";

// images from public folder
const Tick = `${process.env.PUBLIC_URL}/assets/tick.webp`;
const Cross = `${process.env.PUBLIC_URL}/assets/cross.webp`;

export const PricingDetails = [
  {
    id: 1,
    code: "starter",
    name: "Starter Plan",
    description:
      "Ideal for individuals who need quick access to basic features.",
    price: 399,
    yearlyPrice: 399 * 12,
    featureCount: 9,
    features: [
      "Basic sharing(view only, edit only permissions)",
      "Ability to edit sheet and doc files",
      "View, trim and monkup photo and video files",
      "Gmail linking capability",
      "Storage offering: 50GB",
      "Basic user management",
      "Total allowed accounts are 5",
      "Only one Admin role",
      "Limited tracking views only",
      "File locking",
      "Third party app integration",
      "User department specific OCR",
      "Account manager",
      "Advanced encryption and security",
    ],
  },
  {
    id: 2,
    code: "basic",
    name: "Basic Plan",
    description:
      "Ideal for individuals who need advanced features and tools for client work.",
    price: 699,
    yearlyPrice: 699 * 12,
    featureCount: 9,
    features: [
      "All features of Starter Plan",
      "Storage offering: 200GB",
      "Advanced user management",
      "File locking",
      "Password setup for files",
      "Tracking of all user metrics",
      "Online and offline visibility on user management page",
      "Tracking of specific file user is accessing in real time",
      "Unique department color coding system",
      "Additional user roles(Admin, Manager, User)",
      "User department specific OCR",
      "Third party app integration",
      "Advanced encryption and security",
      "Dedicated customer support with account manager",
    ],
  },
  {
    id: 3,
    code: "pro",
    name: "Pro Plan",
    description:
      "Ideal for businesses who need personalized services and security for large teams.",
    price: 1499,
    yearlyPrice: 1499 * 12,
    featureCount: 7,
    features: [
      "All Prior plan offerings",
      "Storage offering: 500GB",
      "Customizable department-based roles and permissions",
      "Integration with third party apps",
      "Advanced encryption and security",
      "Dedicated customer support with account manager",
      "Advanced OCR with cross-department search functionality",
    ],
  },
];

const PricingCard = ({
  plan,
  isSelected,
  isYearly,
  onSelect,
  onContinue,
  buttonText = "Get Started Now",
}) => {
  return (
    <div
      className={`rounded-lg shadow-md border transition-all duration-300 ease-in-out ${
        isSelected ? "border-gray-400 scale-105" : "border-transparent"
      } transition-transform transform bg-white overflow-hidden cursor-pointer`}
      onMouseEnter={onSelect}
    >
      {/* HEADER */}
      <div
        className={`p-6 ${
          isSelected
            ? "bg-gradient-to-r from-[#6C63FF] to-[#7F5CFF] text-white"
            : "bg-white"
        }`}
      >
        <div className="flex items-center justify-between">
          <div>
            <h3
              className={`text-xl font-bold ${
                isSelected ? "text-white" : "text-gray-800"
              }`}
            >
              {plan.name}
            </h3>

            <p
              className={`text-sm mt-2 ${
                isSelected ? "text-white/90" : "text-gray-600"
              }`}
            >
              {plan.description}
            </p>
          </div>

          {isSelected && (
            <div className=" mt-6 rounded-full border-2 border-white w-8 h-8 flex items-center justify-center">
              ✓
            </div>
          )}
        </div>

        {/* PRICE */}
        <div className="mt-6 flex items-center gap-2">
          <p
            className={`text-4xl font-thin ${
              isSelected ? "text-white font-extralight" : "text-gray-600 font-extralight"
            }`}
          >
            ₹{isYearly ? plan.yearlyPrice : plan.price}
          </p>
          <p
            className={`text-sm ${isSelected ? "text-white" : "text-gray-600"}`}
          >
            / {isYearly ? "Year" : "Month"}
          </p>
        </div>

        {/* BUTTON */}
        <button
          onClick={(e) => {
            e.stopPropagation();
            onContinue();
          }}
          className={`mt-6 w-full py-2 rounded ${
            isSelected
              ? "bg-white text-[#5E5ADB]"
              : "bg-transparent border border-[#5E5ADB] text-[#5E5ADB]"
          }`}
        >
          {buttonText}
        </button>
      </div>

      {/* FEATURES */}
      <div className="p-6 pt-2 ">
        {plan.features.map((feature, index) => (
          <span key={index} className="flex items-center gap-2">
            {index < plan.featureCount ? (
              <img
                src={Tick}
                alt=""
                className="p-1.5 w-6 h-6 rounded-full bg-[#5E5ADB]"
              />
            ) : (
              <img
                src={Cross}
                alt=""
                className="p-1.5 w-6 h-6 rounded-full bg-[#F7F8F9]"
              />
            )}
            <p
              className={`text-md my-2 ${
                index >= plan.featureCount ? "text-gray-500" : ""
              }`}
            >
              {feature}
            </p>
          </span>
        ))}
      </div>
    </div>
  );
};

export default PricingCard;
